import { NgModule } from '@angular/core';
import { SStatsCardWorkAccidentComponent } from './s-stats-card-work-accident.component';
import { CommonModule } from '@angular/common';
import { SStatsCardWorkAccidentService } from './s-stats-card-work-accident.service';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { LoadingStateModule, StatsCardModule } from '@seniorsistemas/angular-components';

@NgModule({
    imports: [
        CommonModule,
        StatsCardModule,
        HttpClientModule,
        SharedModule,
        LoadingStateModule
    ],
    declarations: [SStatsCardWorkAccidentComponent],
    providers: [SStatsCardWorkAccidentService],
    exports: [SStatsCardWorkAccidentComponent]
})
export class SStatsCardWorkAccidentModule { }
